<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-07-11 11:42:47
 * @LastEditTime : 2022-07-12 09:12:18
 * @LastEditors  : yangxr
 * @Description  : 泵送量明细弹窗
 * @FilePath     : \icps_zs\src\views\platform\ICPS\smart\schedul\components\pumpingVolumeDialog.vue
-->
<template>
  <el-dialog v-dialogDrag :visible="visible" width="560px" @close="onClose">
    <span slot="title" class="dialog-title">泵送量</span>
    <div class="dialoginfo">
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :span-method="objectSpanMethod" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="pumpingVolumeData" tooltip-effect="dark">
        <el-table-column v-if="source == 2" label="泵送队" prop="pumpingTeam" />
        <el-table-column label="车牌/编号" prop="plateNumber" />
        <el-table-column label="泵机类型" prop="pumpTypeName" />
        <el-table-column label="泵送量" prop="pumpingVolume" />
        <el-table-column label="确认量" prop="confirmationAmount" />
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="onClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    pumpingVolumeData: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    //1泵送作业  2生产排程
    source: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    onClose() {
      this.$emit("update:visible", false);
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 && this.source == 2) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>
<style lang="scss">
.abnormalDialog_form {
  .el-textarea,
  .el-input__inner {
    width: 215px;
  }
}
</style>
